import createReducer from '../utils/createReducer';
import {
  BANKS_REQUEST,
  BANKS_FAILURE,
  BANKS_SUCCESS,
} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [BANKS_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [BANKS_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: payload.data,
      token: payload.token,
    })
  ),
  [BANKS_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/banks.js